<script lang="ts">
  import { Text } from '@squareup/public-web-design-system';
  import DynamicChildrenComponent from '$lib/components/DynamicChildrenComponent/DynamicChildrenComponent.svelte';

  export let tooltip;
  export let title;
</script>

<div class="tooltip" role="tooltip" aria-live="polite">
  <Text variant="50">{@html title}</Text>
  <DynamicChildrenComponent children={[tooltip]} />
</div>

<style lang="scss">
  @use '@squareup/public-web-design-system/dist/tokens/generated-tokens/scss/_media_queries' as mediaQueries;

  @layer custom-components {
    .tooltip {
      --color-text: var(--color-white);
      --color: var(--color-text);
      opacity: 0;
      visibility: hidden;
      position: absolute;
      padding: var(--space-20);
      border-radius: var(--space-10);
      background: var(--color-gray-99);
      box-shadow: 0px 4px 25px 0px rgba(0, 0, 0, 0.25);
      z-index: 98;
      bottom: calc(100% + var(--space-10));
      left: 50%;
      transform: translateX(-50%);
      pointer-events: none;
      min-width: calc(100% - var(--space-20));
      display: flex;
      flex-direction: column;
      gap: var(--space-10);
      transition:
        opacity 0.3s ease-in-out,
        visibility 0.3s ease-in-out;

      :global(.RichTextFieldComponent p) {
        --font-size: var(--text-variant-50-font-size);
      }

      :global(.Text) {
        @include mediaQueries.until('medium') {
          display: none;
        }
      }
    }
  }
</style>
